module.exports = __webpack_public_path__ + "static/media/missed-call.760f52f1.svg";